import { useEffect, useState } from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import "animate.css";
import "../styles/CustomNavbar.css";

const CustomNavbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const location = useLocation(); // Get current location

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Navbar 
      expand="lg" 
      expanded={expanded}
      className={`fixed-top ${scrolled ? "scrolled" : ""}`}
    >
      <Container>
        <Navbar.Brand 
          as={Link} 
          to="/" 
          className="d-flex align-items-center animate__animated animate__fadeInLeft animate__faster"
          onClick={() => setExpanded(false)}
        >
          <span className="brand-text">SARL AGORA GLOBAL</span>
        </Navbar.Brand>
        
        <Navbar.Toggle 
          aria-controls="basic-navbar-nav" 
          className="custom-toggler"
          onClick={() => setExpanded(expanded ? false : true)}
        >
          <span className={`navbar-toggler-icon ${expanded ? "open" : ""}`}></span>
        </Navbar.Toggle>
        
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-lg-center">
            <Nav.Link 
              as={Link} 
              to="/" 
              className="nav-link-item mx-lg-2"
              onClick={() => setExpanded(false)}
            >
              Accueil
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/products" 
              className="nav-link-item mx-lg-2"
              onClick={() => setExpanded(false)}
            >
              Nos Produits
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/inventory" 
              className="nav-link-item mx-lg-2"
              onClick={() => setExpanded(false)}
            >
              Inventaire
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/about" 
              className="nav-link-item mx-lg-2"
              onClick={() => setExpanded(false)}
            >
              À Propos
            </Nav.Link>
            
            <div className="nav-separator d-none d-lg-block"></div>
            
            {/* Only show login button if not on /admin route */}
            {!location.pathname.startsWith("/admin") && (
              <Button
                as={Link}
                to="/admin"
                variant="danger"
                className="login-btn ms-lg-3 mt-3 mt-lg-0 px-3 py-1 rounded-pill"
                style={{ fontWeight: 500, fontSize: "0.95rem", boxShadow: "none" }}
                onClick={() => setExpanded(false)}>
                <i className="bi bi-box-arrow-in-right"></i>
                Login
              </Button>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;
